webpackJsonp([1],{

/***/ "6txZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lfld":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/store/Store.js




vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var Store = (new vuex_esm["a" /* default */].Store({
  state: {
    count: 5,
    allProjects: [],
    projects: [],
    tag: null
  },

  actions: {
    loadProjects: function loadProjects(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      axios_default.a.get('./../static/data.json').then(function (response) {
        commit("FETCH_PROJECTS", response.data.projects);
        commit("FILTER_PROJECTS", state.tag);
      });
    },
    filterProjects: function filterProjects(_ref2, tag) {
      var commit = _ref2.commit;

      commit("FILTER_PROJECTS", tag);
    }
  },

  getters: {
    projects: function projects(state) {
      return state.projects;
    }
  },

  mutations: {
    FETCH_PROJECTS: function FETCH_PROJECTS(state, projects) {
      state.allProjects = projects;
    },
    FILTER_PROJECTS: function FILTER_PROJECTS(state, tag) {
      console.log("filter tag", tag);
      state.tag = tag;
      if (tag == null) {
        state.projects = state.allProjects.concat([]);
      } else {
        console.log(state.allProjects);
        state.projects = state.allProjects.filter(function (o) {
          console.log("filter in ", o.tags);
          return o.tags.indexOf(tag) > -1;
        });
      }
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: 'app',
  mounted: function mounted() {
    Store.dispatch("loadProjects");
    window.addEventListener('resize', this.updateSize.bind(this));
    this.updateSize();
  },


  methods: {
    updateSize: function updateSize() {
      if (window.innerWidth < 980) {
        this.$el.style.fontSize = window.innerWidth / 980 * 16 + "px";
      } else {
        this.$el.style.fontSize = "16px";
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7d3d5dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProjectItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ProjectItem = ({
    name: "ProjectItem",

    props: ["item"],

    computed: {}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c63ba6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectItem.vue
var ProjectItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-item"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.item.title))])]),_vm._v(" "),_c('img',{attrs:{"src":'/static/img/'+_vm.item.banner}}),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"info date"},[_c('span',[_vm._v(_vm._s(_vm.item.date))])]),_vm._v(" "),(_vm.item.links != null && _vm.item.links.length > 0)?_c('div',{staticClass:"info"},[_c('span',[_vm._v("See on :")]),_vm._v(" "),_vm._l((_vm.item.links),function(link){return _c('a',{key:link.url,staticClass:"link",attrs:{"href":link.url,"target":"_blank"}},[_c('i',{class:link.type})])})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tag-container"},_vm._l((_vm.item.tags),function(tag){return _c('router-link',{key:tag,staticClass:"tag",attrs:{"to":{path:'/tag/'+tag}}},[_vm._v("#"+_vm._s(tag))])}))])])}
var ProjectItem_staticRenderFns = []
var ProjectItem_esExports = { render: ProjectItem_render, staticRenderFns: ProjectItem_staticRenderFns }
/* harmony default export */ var components_ProjectItem = (ProjectItem_esExports);
// CONCATENATED MODULE: ./src/components/ProjectItem.vue
function injectStyle (ssrContext) {
  __webpack_require__("xNNX")
}
var ProjectItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ProjectItem___vue_template_functional__ = false
/* styles */
var ProjectItem___vue_styles__ = injectStyle
/* scopeId */
var ProjectItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProjectItem___vue_module_identifier__ = null
var ProjectItem_Component = ProjectItem_normalizeComponent(
  ProjectItem,
  components_ProjectItem,
  ProjectItem___vue_template_functional__,
  ProjectItem___vue_styles__,
  ProjectItem___vue_scopeId__,
  ProjectItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ProjectItem = (ProjectItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProjectList.vue
//
//
//
//
//
//



/* harmony default export */ var ProjectList = ({
    name: "ProjectList",

    props: {
        items: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },

    components: { ProjectItem: src_components_ProjectItem },

    mounted: function mounted() {
        Store.dispatch("filterProjects", this.$route.params.tag);
    },


    watch: {
        "$route.params.tag": function $routeParamsTag(newValue, oldValue) {

            Store.dispatch("filterProjects", newValue);
        }
    },

    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3326552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectList.vue
var ProjectList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-list"},_vm._l((_vm.items),function(item){return _c('project-item',{key:"item.title",attrs:{"item":item}})}))}
var ProjectList_staticRenderFns = []
var ProjectList_esExports = { render: ProjectList_render, staticRenderFns: ProjectList_staticRenderFns }
/* harmony default export */ var components_ProjectList = (ProjectList_esExports);
// CONCATENATED MODULE: ./src/components/ProjectList.vue
function ProjectList_injectStyle (ssrContext) {
  __webpack_require__("Lfld")
}
var ProjectList_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ProjectList___vue_template_functional__ = false
/* styles */
var ProjectList___vue_styles__ = ProjectList_injectStyle
/* scopeId */
var ProjectList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProjectList___vue_module_identifier__ = null
var ProjectList_Component = ProjectList_normalizeComponent(
  ProjectList,
  components_ProjectList,
  ProjectList___vue_template_functional__,
  ProjectList___vue_styles__,
  ProjectList___vue_scopeId__,
  ProjectList___vue_module_identifier__
)

/* harmony default export */ var src_components_ProjectList = (ProjectList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Top.vue
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Top = ({
    name: "Top",

    computed: {
        currentTag: function currentTag() {
            return this.$route.params.tag;
        }
    },

    components: {},

    mounted: function mounted() {
        console.log(this.$route);
    },
    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26520d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
var Top_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_vm._m(0,false,false),_vm._v(" "),(_vm.currentTag != null)?_c('router-link',{staticClass:"current-tag",attrs:{"to":{path:'/'}}},[_vm._v("#"+_vm._s(_vm.currentTag)),_c('i',{staticClass:"icon-cancel-circled-outline"})]):_vm._e()],1)}
var Top_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"twitter-account",attrs:{"href":"https://twitter.com/chloridrik","target":"_blank"}},[_c('span',{staticClass:"profile-picture"}),_vm._v(" "),_c('span',[_vm._v("@chloridrik // portfolio")])])}]
var Top_esExports = { render: Top_render, staticRenderFns: Top_staticRenderFns }
/* harmony default export */ var components_Top = (Top_esExports);
// CONCATENATED MODULE: ./src/components/Top.vue
var Top_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Top___vue_template_functional__ = false
/* styles */
var Top___vue_styles__ = null
/* scopeId */
var Top___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Top___vue_module_identifier__ = null
var Top_Component = Top_normalizeComponent(
  Top,
  components_Top,
  Top___vue_template_functional__,
  Top___vue_styles__,
  Top___vue_scopeId__,
  Top___vue_module_identifier__
)

/* harmony default export */ var src_components_Top = (Top_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/Home.vue
//
//
//
//
//
//
//




/* harmony default export */ var Home = ({
    name: 'Home',

    components: { ProjectList: src_components_ProjectList, Top: src_components_Top },

    data: function data() {
        return {};
    },


    computed: {
        items: function items() {
            return Store.getters.projects;
        }
    },

    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b244338","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-view"},[_c('top'),_vm._v(" "),_c('project-list',{attrs:{"items":_vm.items}})],1)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var view_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/view/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("Yeqq")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-5b244338"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  view_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_view_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: src_view_Home
  }, {
    path: '/tag/:tag',
    name: "Tag",
    component: src_view_Home
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
__webpack_require__("6txZ");




vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Yeqq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xNNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b1306010190e2fe11064.js